"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QRBackgroundColor = void 0;
const QRBackgroundColor = exports.QRBackgroundColor = {
  Green: 'green',
  Blue: 'blue',
  Purple: 'purple',
  Pink: 'pink',
  Brown: 'brown',
  White: 'white'
};
